export const SOCIAL_PROVIDER_TYPE = {
  OTHER: 'other',
  GOOGLE: 'google',
  FACEBOOK: 'facebook',
  APPLE: 'apple',
} as const;

type ObjectValues<T> = T[keyof T];

export type SocialProviderType = ObjectValues<typeof SOCIAL_PROVIDER_TYPE>;

export default class SocialProvider {
  provider: SocialProviderType;

  userKey?: string;

  authId?: string;

  auth: boolean;
}
